// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form":"form___3-e1X","row":"row___13LVf","full":"full___36FTS","half":"half___2T4-w"};